import BaseController from "confinus_ui/base_controller";
import { showModal } from "lib/overlay/modal";
import { markAsSafeHTML } from "lib/util/safe_html";

export default class ModalOpenButtonController extends BaseController {
  public static values = {
    contentHref: { type: String, default: null },
    initialContent: { type: String, default: null },
    closeOnOverlayClick: Boolean,
  };

  declare private readonly contentHrefValue?: string;
  declare private readonly initialContentValue?: string;
  declare private readonly closeOnOverlayClickValue?: boolean;
  public handleButtonClick(event: Event) {
    event.preventDefault();

    showModal({
      contentHref: this.contentHrefValue,
      closeOnOverlayClick: this.closeOnOverlayClickValue,
      placeholder: this.initialContentValue
        ? markAsSafeHTML(this.initialContentValue)
        : undefined,
    });
  }
}
